/**
 * The score Match Lab thinks the match ended (Ben, 2026-10-22): the GOAL
 * labels added up by side — what people found and labeled — beside the
 * detected goals' score, flagged when the two disagree (a goal missed, or
 * one detected that never happened). A goal label with no side is shown
 * apart, never guessed into either column.
 */
export type GoalScore = { home: number; away: number; unsided: number }

const DASH = '–'
const AMBER = '#d97706'

export function MatchScore({ labeled, detected }: {
  /** From every GOAL label (labels GET goal_score); null until loaded. */
  labeled: GoalScore | null
  /** The detected goals' score; null when nothing was detected. */
  detected: { home: number; away: number } | null
}) {
  const nLabeled = labeled ? labeled.home + labeled.away + labeled.unsided : 0
  if (!labeled || nLabeled === 0) {
    return detected
      ? <span className="muted" style={{ fontSize: '13px' }}
              title="No goal labels yet: the detected goals' score">
          (detected {detected.home}{DASH}{detected.away})
        </span>
      : null
  }
  // The counts per team: an unsided label is flagged on its own, beside.
  const differs = detected != null
    && (detected.home !== labeled.home || detected.away !== labeled.away)
  return (
    <span style={{ display: 'inline-flex', alignItems: 'baseline', gap: '6px',
                   fontSize: '13px' }}
          aria-label="Score from goal labels">
      <strong style={{ fontSize: '15px' }}
              title={`From ${nLabeled} goal label${nLabeled === 1 ? '' : 's'}`}>
        {labeled.home}{DASH}{labeled.away}
      </strong>
      <span className="muted">labeled</span>
      {labeled.unsided > 0 && (
        <span style={{ color: AMBER }}
              title="Goal labels with no team: not counted for either side">
          +{labeled.unsided} with no team
        </span>
      )}
      {detected && (
        <span style={{ color: differs ? AMBER : undefined }}
              className={differs ? undefined : 'muted'}
              title={differs ? 'The detected goals and the labels disagree'
                             : 'The detected goals agree'}>
          · detected {detected.home}{DASH}{detected.away}
        </span>
      )}
    </span>
  )
}
